import { PropsWithChildren } from 'react'
import { createGenericContext } from '@/Shared/ui/createGenericContext'
import { TpvsRepository } from '@/Store/domain'
import {
  UseExcelUploadController,
  useExcelUploadController,
} from '@/Store/ui/hooks'

type Context = UseExcelUploadController
type Props = PropsWithChildren & {
  repository: TpvsRepository
  merchantTargetId: number
}

const [useExcelUpload, StateContextProvider] = createGenericContext<Context>()

const ExcelUploadProvider = ({
  repository,
  merchantTargetId,
  children,
}: Props): JSX.Element => {
  const hook = useExcelUploadController(repository, merchantTargetId)

  return <StateContextProvider value={{ ...hook }}>{children}</StateContextProvider>
}

export { ExcelUploadProvider, useExcelUpload }
